import { hasAdminPermission as hasAdminPermissionNewLocation } from "shared/admin-permissions/hasAdminPermission";

/**
 * @deprecated Import from `shared/admin-permissions/hasAdminPermission`
 */
export const hasAdminPermission = hasAdminPermissionNewLocation;
